import React from 'react'
import { Link } from 'gatsby'

class FeaturedIn extends React.Component {
  render() {
    return (
      <div className="category__popular">
        Featured in
        <div>
          <Link
            to={`/categories/${this.props.slug}/`}
            style={{ color: this.props.color }}
          >
            {this.props.category}
          </Link>
        </div>
      </div>
    )
  }
}
export default FeaturedIn
